// Librerias
import React from 'react'
let PropTypes = React.PropTypes
import * as css from './TablaFacturas.css'
export class RowFactura extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    render(){
        return (
            <tr key={1}>
                <td>{this.props.correlativo}</td>
                <td className={css.tdDocumento}>{this.props.factura.fac_tipoDocumento}</td>
                <td className={css.tdNumero}>{this.props.factura.fac_folio}</td>
                <td className={css.tdFecha}>{this.props.factura.fac_fechaEmision}</td>
                <td className={css.tdFecha}>{this.props.factura.fac_fechaVencimiento}</td>
                <td className={css.tdMonto}>{'$'+this.props.factura.fac_totalNeto}</td>
                <td className={css.tdMonto}>{'$'+this.props.factura.fac_totalBruto}</td>
                <td className={css.tdDescarga}>
                    <BotonDescarga
                        publicID = {this.props.factura.fac_idFacturaPublic}
                    />    
                </td>
            </tr>
        )
    }
}
RowFactura.propTypes = {
    factura: PropTypes.object,
    correlativo: PropTypes.number
}
const BotonDescarga = ({publicID})=>
    <a className={'btn btn-sm btn-success pull-right'}
       href={`/facturacion/${publicID}/descargar/pdf`}>
        <span className={'glyphicon glyphicon-link'}></span>
        {' DESCARGA PDF'}
    </a>


// WEBPACK FOOTER //
// ./frontEnd/facturacion/lista-facturas/cliente-fcv/RowFactura.jsx